export default __webpack_public_path__ + "static/media/wazdan.f2da1449.jpg";